var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M18.752 4.621a.627.627 0 0 1 .443 1.07l-5.954 5.956-.353.353.353.354 5.952 5.954a.627.627 0 0 1-.886.886l-5.952-5.954-.354-.353-.353.353-5.955 5.952a.627.627 0 0 1-.964-.79l.078-.096 5.954-5.953.353-.353-.353-.354-5.952-5.954a.627.627 0 0 1 .886-.886l5.953 5.954.353.353.354-.353 5.954-5.955a.63.63 0 0 1 .443-.184Z"
  })));
};
export default SvgClose;